/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { schema3OtherDisconnectApiV1SandboxGithubOauthConnectionsDelete } from "../../funcs/schema3OtherDisconnectApiV1SandboxGithubOauthConnectionsDelete.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .DisconnectApiV1SandboxGithubOauthConnectionsDeleteRequest$inboundSchema,
};

export const tool$schema3OtherDisconnectApiV1SandboxGithubOauthConnectionsDelete:
  ToolDefinition<typeof args> = {
    name:
      "schema-3-other-disconnect-api-v1-sandbox-github-oauth-connections-delete",
    description: `Disconnect`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await schema3OtherDisconnectApiV1SandboxGithubOauthConnectionsDelete(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      return formatResult(void 0, apiCall);
    },
  };
